import React from 'react'
import AppTable from './AppTable'
import { ATTablePaginationProps } from './ATTableProps'
import AppPagination from './AppPagination'

const AppTablePagination: React.FC<ATTablePaginationProps> = ({
  data,
  limit,
  handlePageChange,
  currentPage,
  handlePageSize,
  columns,
  minHeight = 400,
}) => {
  return (
    <div className="col-md-12 flex-col">
      <div
        className="table-bg flex-1"
        id="tableScrollList"
        style={{
          minHeight:
            typeof minHeight === 'number' ? `${minHeight}px` : minHeight,
        }}
      >
        <div className="pos-rel h-100">
          <div className="scrollable-content">
            <AppTable data={data?.data ?? []} columns={columns} />
          </div>
        </div>
      </div>
      <div className="row p-2">
        <AppPagination
          currentPage={currentPage}
          totalCount={data?.totalCount ?? 0}
          pageSize={limit}
          onPageChange={handlePageChange}
          handlePageSize={handlePageSize}
        />
      </div>
    </div>
  )
}

export default React.memo(AppTablePagination)
